import React from 'react';
import Problem from './Problem';

export default function ProblemsList({list}) {
  if (!list) {return "Error: no problem list provided";}
  return <div className="problem-list">
    {list.map((p, i) => <Problem data={p} key={i} listItem />)}
  </div>;
};
